var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { Calendar } from "./Calendar";
import { IconClose } from "../Icons";
import { Button } from "../Button";
import { TimeOptions } from "./TimeOptions";
import { labelsToUnit } from "../../utils/date";
export const Overlay = (_a) => {
    var { onChange, onClose, align, stats, timeRange, defaultTimeRange, allowedTimeRange, timeOptions } = _a, props = __rest(_a, ["onChange", "onClose", "align", "stats", "timeRange", "defaultTimeRange", "allowedTimeRange", "timeOptions"]);
    const [optionValue, setOptionValue] = React.useState();
    const [option, setOption] = React.useState(undefined);
    const handleReset = () => {
        onChange(defaultTimeRange);
        onClose();
    };
    const handleOnApply = () => {
        onClose();
        if (option.type === "fixed") {
            onChange(Object.assign({}, option));
        }
        else if (option.type === "input") {
            onChange({
                label: `Last ${optionValue} ${option.unit}`,
                to: "now",
                from: `now-${optionValue}${labelsToUnit[option.unit]}`,
            });
        }
        else if (option.type === "select") {
            const isYear = option.unit.includes("year");
            const currentYear = new Date().getFullYear();
            const currentValue = isYear ? currentYear : new Date().getMonth() + 1;
            const newValue = optionValue || currentValue;
            onChange({
                label: `${option.label}: ${isYear
                    ? newValue
                    : new Date(0, newValue, 0).toLocaleString("default", {
                        month: "short",
                    })}`,
                to: isYear
                    ? new Date(newValue, 11, 31)
                    : new Date(currentYear, newValue, 0),
                from: isYear
                    ? new Date(newValue, 0, 1)
                    : new Date(currentYear, newValue - 1, 0),
            });
        }
        else if (stats.isHistorical || option.type === "absolute") {
            const fromStr = option.from.toLocaleDateString();
            const toStr = option.to.toLocaleDateString();
            onChange(Object.assign(Object.assign({}, option), { label: toStr === fromStr ? toStr : `${fromStr} - ${toStr}` }));
        }
    };
    return (React.createElement("div", { className: "tnic-overlay", style: align ? { [align]: 0 } : {} },
        React.createElement("div", { className: "tnic-header" },
            React.createElement("div", { className: "tnic-title" }, "Select time range"),
            React.createElement("div", { style: { display: "flex", alignItems: "center" } },
                defaultTimeRange && (React.createElement(Button, { compact: true, basic: true, onClick: handleReset }, "Reset")),
                React.createElement(Button, { compact: true, basic: true, icon: true, onClick: () => onClose() },
                    React.createElement(IconClose, null)))),
        React.createElement("div", { style: {
                display: "flex",
                flexDirection: align === "right" ? "row-reverse" : "row",
                justifyContent: "space-between",
                flex: 1,
            } },
            !stats.isHistorical && (React.createElement("div", { className: "tnic-overlay--container" },
                React.createElement(TimeOptions, { align: align, timeOptions: timeOptions, onSelect: (option, value) => {
                        setOptionValue(value);
                        setOption(option);
                    }, active: option }))),
            (stats.isHistorical || (option === null || option === void 0 ? void 0 : option.type) === "absolute") && (React.createElement("div", { style: Object.assign({ float: "right", flex: 1, width: "550px", height: "336px" }, (align === "right"
                    ? {
                        borderRight: "1px solid #ccc",
                    }
                    : {
                        borderLeft: "1px solid #ccc",
                    })) },
                React.createElement(Calendar, { timeRange: timeRange, minDate: (allowedTimeRange === null || allowedTimeRange === void 0 ? void 0 : allowedTimeRange.from) || stats.from, maxDate: (allowedTimeRange === null || allowedTimeRange === void 0 ? void 0 : allowedTimeRange.to) || stats.to, numberOfMonths: 2, onChange: (range) => {
                        setOption(Object.assign(Object.assign({}, option), range));
                    } })))),
        React.createElement("div", { className: "tnic-footer" },
            React.createElement("span", null,
                React.createElement(Button, { compact: true, basic: true, onClick: onClose }, "Cancel"),
                React.createElement(Button, { compact: true, onClick: handleOnApply, disabled: !option }, "Apply")))));
};
//# sourceMappingURL=Overlay.js.map